import { SOLUTION_AVATARS } from "./solutionAvatars";

// Mensagens do card animado de chats unificados. Exemplo ilustrativo: textos e
// lojas fictícios — a legenda do card diz isso a quem escuta a página.

export type SolutionChat = {
  store: number;
  avatar: string;
  message: string;
};

export const SOLUTION_CHATS: SolutionChat[] = [
  {
    store: 2,
    avatar: SOLUTION_AVATARS[0],
    message: "Vou sábado na loja, esqueci de pagar.",
  },
  {
    store: 1,
    avatar: SOLUTION_AVATARS[6],
    message: "Acabei esquecendo de pagar, me manda o Pix?",
  },
  {
    store: 3,
    avatar: SOLUTION_AVATARS[2],
    message: "Obrigado por me lembrar, já efetuei o pagamento.",
  },
  {
    store: 4,
    avatar: SOLUTION_AVATARS[5],
    message: "Posso dividir a parcela em duas vezes?",
  },
  {
    store: 2,
    avatar: SOLUTION_AVATARS[1],
    message: "Paguei agora pelo link, pode conferir?",
  },
  {
    store: 1,
    avatar: SOLUTION_AVATARS[7],
    message: "Me manda o boleto atualizado, por favor.",
  },
];
